import { AxiosRequestConfig } from 'axios';

const hasSearchParams = (params: AxiosRequestConfig['params']): boolean => {
    if (!params || typeof params !== 'object') {
        return false;
    }

    const record = params as Record<string, unknown>;

    return Boolean(
        record.searchStr ??
            record.search_str ??
            record.searchString ??
            record.search_string,
    );
};

export const isCatalogSearchRequestUrl = (url: string | undefined): boolean => {
    if (!url) {
        return false;
    }

    return (
        url.includes('/catalogs/search-items') || /\/catalogs\/[^/?]+/.test(url)
    );
};

export const isCatalogSearchRequest = (config: AxiosRequestConfig): boolean => {
    const url = config.url;

    if (!url) {
        return false;
    }

    if (url.includes('/catalogs/search-items')) {
        return true;
    }

    if (/\/catalogs\/[^/?]+/.test(url)) {
        return hasSearchParams(config.params);
    }

    return false;
};
